module.exports = __webpack_public_path__ + "static/media/dice.e6c2c1c7.png";